import Country from 'model/Country';
import { Component } from 'react';
import { addFlux, AddFluxHOCProps } from 'components/wrappers/WithFlux';

interface CountryProviderState {
  countries?: Country[];
}

interface CountryProviderProps {
  children: (e: CountryProviderState) => any;
}

class CountryProvider extends Component<CountryProviderProps & AddFluxHOCProps, CountryProviderState> {
  state = this.getStateFromStore();

  componentDidMount() {
    this.props.flux.stores.LocationsStore.on('change', this.onStoreChange);
    const countries = this.props.flux.stores.LocationsStore.getCountries().data;

    if (!countries || countries.length === 0) {
      setTimeout(() => this.props.flux.actions.locations.fetchCountries());
    }
  }

  componentWillUnmount() {
    this.props.flux.stores.LocationsStore.removeListener('change', this.onStoreChange);
  }

  getStateFromStore() {
    const countries = this.props.flux.stores.LocationsStore.getCountries().data || [];

    return { countries };
  }

  onStoreChange = () => {
    this.setState(this.getStateFromStore());
  };

  render() {
    return this.props.children({ ...this.state });
  }
}

export default addFlux(CountryProvider);
